import React, { useState, useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { AiOutlineRollback, AiFillEdit } from "react-icons/ai";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeById,
  resetEmployeeUpdate,
  updateEmployee,
  getAllEmployees,
  resetEmployeeDetails,
} from "../features/employee/employeeSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";

const UpdateEmployee = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [employeeImage, setEmployeeImage] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employeeNid, setEmployeeNid] = useState("");
  const [employeePhone, setEmployeePhone] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeeCommission, setEmployeeCommission] = useState(0);
  const [employeeSalary, setEmployeeSalary] = useState("");
  const [loanTaken, setLoanTaken] = useState(0);
  const [monthlyDeduction, setMonthlyDeduction] = useState(0);
  const [employeeAddress, setEmployeeAddress] = useState("");

  const [employeeUsername, setEmployeeUsername] = useState("");
  const [employeePassword, setEmployeePassword] = useState("");

  const [openUserInfo, setOpenUserInfo] = useState(false);

  // selectors
  const {
    employee,

    isDetailsLoading,
    isDetailsError,
    isDetailsSuccess,
    detailsErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.employee);

  const {
    userInfo,
    user,
    isUpdateLoading: isUserUpdateLoading,
    isUpdateSuccess: isUserUpdateSuccess,
    isUpdateError: isUserUpdateError,
    updateErrorMessage: updateUserErrorMessage,
  } = useSelector((state) => state.user);

  //Employee State
  // const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login to Get Access", { position: "top-center" })
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setEmployeeImage(employee.image);
      setEmployeeName(employee.fullName);
      setEmployeeNid(employee.nid);
      setEmployeePhone(employee.phone);
      setEmployeeEmail(employee.email);
      setEmployeeCommission(employee.commission);
      setEmployeeSalary(employee.salary);
      setLoanTaken(employee.loan);
      setMonthlyDeduction(employee.monthlyDeduction);
      setEmployeeAddress(employee.address);

      setEmployeeUsername(employee.user?.userName);
      setEmployeePassword(employee.user?.password);
    } else {
      dispatch(getEmployeeById(params.id));
    }
  }, [isDetailsError, isDetailsSuccess, detailsErrorMessage]);


  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Employee Updated Successfully", {
        position: "top-center",
      });
      dispatch(getAllEmployees());
      navigate("/officeAgentList");
    }
  }, [isUpdateError, isUpdateSuccess, updateErrorMessage, navigate]);

  useEffect(() => {
    return () => {
      dispatch(resetEmployeeDetails());
      dispatch(resetEmployeeUpdate());
    };
  }, [dispatch]);

  const updateHandler = () => {
    if (
      employeeUsername !== "" &&
      employeePassword !== "" &&
      employeeName !== "" &&
      employeeNid !== "" &&
      employeePhone !== ""
    ) {
      const employeeData = {
        image: employeeImage,
        fullName: employeeName,
        nid: employeeNid,
        phone: employeePhone,
        email: employeeEmail,
        commission: employeeCommission,
        salary: employeeSalary,
        loan: loanTaken,
        monthlyDeduction: monthlyDeduction,
        address: employeeAddress,
      };

      const userData = {
        userName: employeeUsername,
        password: employeePassword,
      };

      dispatch(
        updateEmployee({
          id: params.id,
          employeeData,
          userData,
        })
      );
    } else if (
      employeeUsername === "" &&
      employeePassword === "" &&
      employeeName !== "" &&
      employeeNid !== "" &&
      employeePhone !== ""
    ) {
      const employeeData = {
        image: employeeImage,
        fullName: employeeName,
        nid: employeeNid,
        phone: employeePhone,
        email: employeeEmail,
        commission: employeeCommission,
        salary: employeeSalary,
        loan: loanTaken,
        monthlyDeduction: monthlyDeduction,
        address: employeeAddress,
      };

      // const userData = null;

      dispatch(
        updateEmployee({
          id: params.id,
          employeeData,
          // userData,
        })
      );
    } else if (employeeUsername !== "" && employeePassword === "") {
      toast.error("Please Enter Password", { position: "top-center" });
    } else if (employeeUsername === "" && employeePassword !== "") {
      toast.error("Please Enter Username", { position: "top-center" });
    } else {
      toast.error("Please Fill All Required Fields", {
        position: "top-center",
      });
    }
  };

  const handleOpenUserInfo = () => {
    setOpenUserInfo(!openUserInfo);
  };

  // Employee Image Upload
  const uploadImageFileHandler = async (event) => {
    const file = event.target.files[0];

    const formData = new FormData();
    formData.append("image", file);
    // if (file) {
    //   const reader = new FileReader();

    //   reader.onload = () => {
    //     setSelectedImage(reader.result);
    //     // setEmployeeImage(reader.result);
    //   };

    //   reader.readAsDataURL(file);
    // }

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `/api/v1/upload${employeeImage ? `/${employeeImage.slice(8)}` : ""}`,
        formData,
        config
      );
      // officeAgentImage(data)
      setEmployeeImage(data);
    } catch (error) {
      console.error(error);
    }
  };

  // const uploadImageFileHandler = async (e) => {
  //   const file = e.target.files[0]
  //   const formData = new FormData()
  //   formData.append('image', file)
  //   try {
  //     const config = {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     }

  //     const { data } = await axios.post(
  //       `/api/v1/upload${employeeImage ? `/${employeeImage.slice(8)}` : ''}`,
  //       formData,
  //       config
  //     )
  //     setEmployeeImage(data)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // const UpdateOfficeAgent = () => {
  //   const [officeAgentImage, setOfficeAgentImage] = useState("");

  //   const uploadImageFileHandler = async (e) => {
  //     const file = e.target.files[0];
  //     const formData = new FormData();
  //     formData.append("image", file);
  //     try {
  //       const config = {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       };

  //       const { data } = await axios.post(
  //         `/api/v1/upload${
  //           officeAgentImage ? `/${officeAgentImage.slice(8)}` : ""
  //         }`,
  //         formData,
  //         config
  //       );
  //       officeAgentImage(data);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //Image Upload Employee
  // const uploadImageHandler = async (e) => {
  //   const file = e.target.files[0];
  //   const formData = new FormData();
  //   formData.append("employeeImage", file);
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     };

  //     const { data } = await axios.post(
  //       `/api/v1/upload${employeeImage ? `/${employeeImage.slice(8)}` : ""}`,
  //       formData,
  //       config
  //     );
  //     setEmployeeImage(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []),
    (
      <>
        {isDetailsLoading || isUpdateLoading ? (
          <Loader />
        ) : isDetailsError ? (
          <h4 variant="danger">{detailsErrorMessage}</h4>
        ) : (
          <Container fluid className="my-4">
            <h2 style={{ fontWeight: "bold" }} className="mb-4 text-center">
              Update Employee
            </h2>

            <Form>
              <Row>
                {/* Column for Upload Files  */}
                <Col sm={12} md={4} lg={3}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Update Image
                    </Card.Header>
                    <Card.Body className="text-center">
                      <Card.Img
                        cascade
                        className="img-fluid rounded"
                        src={
                          employeeImage !== ""
                            ? employeeImage
                            : "http://bootdey.com/img/Content/avatar/avatar7.png"
                        }
                        style={{ height: "20vh" }}
                      />
                      <div className="small font-italic text-muted mt-3">
                        JPG or PNG no larger than 5 MB
                      </div>
                      <Form.Group controlId="image 1">
                        <Form.Label className="py-3">Upload Image</Form.Label>
                        <Form.Control
                          //required
                          className="mb-3 rounded"
                          type="file"
                          id="image-file"
                          label="employeeImage"
                          controlId="employeeImage"
                          onChange={uploadImageFileHandler}
                        ></Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Column For Form */}
                <Col sm={12} md={8} lg={9}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black fw-bold p-3 text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Update Office Agent
                    </Card.Header>
                    <Card.Body className="fw-bold">
                      <Row>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="employeeName">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder={
                                employeeName === ""
                                  ? "Full Name is Required"
                                  : "Enter Full Name"
                              }
                              value={employeeName}
                              onChange={(e) => setEmployeeName(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="NIDNumber">
                            <Form.Label>NID Number</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder={
                                employeeNid === ""
                                  ? "NID Number is Required"
                                  : "Enter NID Number"
                              }
                              value={employeeNid}
                              onChange={(e) => setEmployeeNid(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="PhoneNumber">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder={
                                employeePhone === ""
                                  ? "Phone Number is Required"
                                  : "Enter Phone Number"
                              }
                              value={employeePhone}
                              onChange={(e) => setEmployeePhone(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="AgentEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              // required
                              type="email"
                              placeholder="Enter Email"
                              value={employeeEmail}
                              onChange={(e) => setEmployeeEmail(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="AgentSalary">
                            <Form.Label>Salary</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder={
                                employeeSalary === ""
                                  ? "Salary is Required"
                                  : "Enter Salary"
                              }
                              value={employeeSalary}
                              onChange={(e) =>
                                setEmployeeSalary(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="commission">
                            <Form.Label>Commission</Form.Label>
                            <Form.Control
                              // required
                              type="number"
                              placeholder="Enter Commission"
                              value={employeeCommission}
                              onChange={(e) =>
                                setEmployeeCommission(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="loanTaken">
                            <Form.Label>Loan Taken</Form.Label>
                            <Form.Control
                              // required
                              type="number"
                              placeholder="Enter Amount of Loan Taken"
                              value={loanTaken}
                              onChange={(e) => setLoanTaken(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="monthlyDeduction">
                            <Form.Label>Monthly Deduction</Form.Label>
                            <Form.Control
                              // required
                              type="number"
                              placeholder="Monthly Deduction Amount"
                              value={monthlyDeduction}
                              onChange={(e) =>
                                setMonthlyDeduction(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group controlId="AgentAddress">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              // required
                              type="textarea"
                              as="textarea"
                              rows={2}
                              placeholder="Enter Address"
                              value={employeeAddress}
                              onChange={(e) =>
                                setEmployeeAddress(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      {userInfo && userInfo.userType === "admin" ? (
                        <>
                          <Row className="px-3 mb-3 mt-4">
                            <Col>
                              <Button
                                variant="outline-primary"
                                // type="submit"
                                className="rounded"
                                onClick={handleOpenUserInfo}
                              >
                                {openUserInfo ? "Close" : "Update Login Info"}
                              </Button>
                            </Col>
                          </Row>

                          {openUserInfo && (
                            <Card.Body>
                              <Row className="mb-3">
                                <Col sm={12} md={6} lg={6}>
                                  <Form.Group controlId="employeeUsername">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                      required={
                                        employeePassword !== "" ? true : false
                                      }
                                      value={employeeUsername}
                                      type="text"
                                      placeholder="Enter Username"
                                      onChange={(e) =>
                                        setEmployeeUsername(e.target.value)
                                      }
                                    ></Form.Control>
                                  </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                  <Form.Group controlId="employeePassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                      required={
                                        employeeUsername !== "" ? true : false
                                      }
                                      value={employeePassword}
                                      type="text"
                                      placeholder="Enter Password"
                                      onChange={(e) =>
                                        setEmployeePassword(e.target.value)
                                      }
                                    ></Form.Control>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          )}
                        </>
                      ) : null}

                      <Row className="mt-4">
                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <Button
                              variant="outline-primary"
                              // type="submit"
                              className="rounded"
                              onClick={updateHandler}
                            >
                              <AiFillEdit className="mb-1" size={18} /> Update
                              Agent
                            </Button>
                          </Row>
                        </Col>

                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <LinkContainer to="/officeAgentList">
                              <Button
                                variant="outline-secondary"
                                // type="submit"
                                className="rounded"
                              >
                                <AiOutlineRollback className="mb-1" size={18} />{" "}
                                Go Back To List
                              </Button>
                            </LinkContainer>
                          </Row>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Container>
        )}
      </>
    )
  );
};

export default UpdateEmployee;
